import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import isFunction from 'lodash/isFunction';

import { loginUser, registerUser } from 'services/authService';
import getTokenFromStorage from 'utils/getTokenFromStorage';
import { getUserBasicData, updateUserProfile } from 'services/userService';
import { UserFormData, UserResponseViewModel } from 'types/user';
import { NotificationMessage } from 'types/snackbar';
import { SignUpFormData } from 'types/auth';
import { UpdateUserProfileRequest } from 'api/user/types';

const base = '@CLILLC/session';

export const storeUser = createAction(`${base}/store-user`, (payload: UserResponseViewModel | null) => ({
    payload,
}));

export const login = createAsyncThunk(
    `${base}/login`,
    async (params: { email: string; password: string; onSuccess?: () => void }) => {
        const loginResp = await loginUser(params.email, params.password);
        const userInfo = await getUserBasicData(loginResp.token);

        if (isFunction(params.onSuccess)) {
            params.onSuccess();
        }
        return userInfo;
    },
);

export const signUp = createAsyncThunk(
    `${base}/sign-up`,
    async (params: { data: SignUpFormData; onSuccess?: (msg: NotificationMessage) => void }) =>
        registerUser(params.data).then(() => {
            if (isFunction(params.onSuccess)) {
                params.onSuccess({ message: 'Success! Please verify email via the link sent by email' });
            }
        }),
);

export const logout = createAsyncThunk(`${base}/logout`, () => {
    localStorage.clear();
    logout();
    window.location.reload();
});

export const initializeSession = createAsyncThunk(`${base}/initialize`, () => {
    const token = getTokenFromStorage();
    if (token) return getUserBasicData(token);

    // Default case.
    return Promise.reject();
});

export const updateUserProfileAction = createAsyncThunk(
    `${base}/update-user-profile`,
    (params: { user: UserFormData; userId: string; onSuccess: (message: NotificationMessage) => void }) =>
        updateUserProfile(params.user, params.userId).then((profile) => {
            params.onSuccess({ message: 'Successfully updated' });
            return profile;
        }),
);

// export const updateUserPassword = createAsyncThunk(
//     `${base}/update-user-password`,
//     (params: { newPassword: string; oldPassword: string; onSuccess: (message: NotificationMessage) => void }) =>
//         changeUserPassword(params.oldPassword, params.newPassword).then((result) => {
//             params.onSuccess({ message: 'Successfully updated' });
//             return result;
//         }),
// );

// export const resetPassword = createAsyncThunk(
//     `${base}/password-reset`,
//     ({
//         onSuccess,
//         callback,
//         ...params
//     }: {
//         newPassword: string;
//         resetToken: string;
//         userId: string;
//         onSuccess: (message: NotificationMessage) => void;
//         callback: () => void;
//     }) =>
//         createAccountPasswordReset(params).then(() => {
//             onSuccess({ message: 'Successfully updated' });
//             callback();
//         }),
// );

// export const sendResetEmail = createAsyncThunk(
//     `${base}/send-reset-email`,
//     (params: { email: string; callback: () => void; onSuccess: (message: NotificationMessage) => void }) =>
//         createAccountPasswordResetEmail(params.email).then(() => {
//             params.onSuccess({ message: 'The reset link has been sent to your email' });
//             params.callback();
//         }),
// );
